import React from "react";
import About from "../../components/homeAbout";
import Menu from "../../components/homeMenu";
import Dining from "../../components/homeDining";
import Review from "../../components/homeReview";
import CarouselView from "../../components/carouselView";
import Banner from "../../components/banner";

export default function Home() {
  return (
    <>
      <Banner />
      <About />
      <Dining />
      <Menu />
      {/* <Review /> */}
      <CarouselView />
    </>
  );
}
